import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { generateUniqId } from 'helpers/commonHelpers';
import { getPlaceholderForSelect } from '../utils';
import { INTAKE_FORM_FIELDS_GRID_SIZES } from 'constants/grids';
import { FormValuesModel, IndividualFormItem } from '.';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';

// components
import FieldIssue from '../FieldIssue';
import SubmitButtons from '../SubmitButtons';
import IndividualForm from './IndividualForm';
import HideIfDisabledForm from 'components/Forms/HideIfDisabledForm';
import TrueFalseSelect, {
  IProps as TrueFalseSelectProps,
} from 'components/Forms/FormComponents/SelectInputs/TrueFalseSelect';
import { Col, Row, Divider, FormField, Button } from '@ui';

const InnerForm = () => {
  const { t } = useTranslation('onboarding');
  const { values, setFieldValue } = useFormikContext<FormValuesModel>();

  const renderIndividuals = (helpers: FieldArrayRenderProps) => {
    const canRemoveIndividuals = values.individuals.length > 1;
    return (
      <Row gutter={[16, 16]}>
        {values.individuals.map((e, i) => (
          <Col key={e.id} span={24}>
            <IndividualForm
              index={i}
              fieldName={`individuals.${i}`}
              deleteCallback={
                canRemoveIndividuals ? () => helpers.remove(i) : undefined
              }
            />
          </Col>
        ))}
      </Row>
    );
  };

  const addNewIndividual = () => {
    const newIndividuals: IndividualFormItem[] = [
      ...values.individuals,
      {
        id: `custom-${generateUniqId()}`,
        fullName: '',
        country: null,
        relationship: '',
      },
    ];
    setFieldValue('individuals', newIndividuals);
  };

  return (
    <>
      <Row wrap={true} justify="start">
        <Col {...INTAKE_FORM_FIELDS_GRID_SIZES}>
          <FormField<TrueFalseSelectProps>
            label={
              <FieldIssue fieldId="hasOtherBeneficialOwners">
                {t('intake_form.associated_individuals.are_individuals')}
              </FieldIssue>
            }
            name="areIndividuals"
            component={TrueFalseSelect}
            additionalProps={{
              renderPlaceholder: (validationRules) =>
                getPlaceholderForSelect(validationRules, true, false, t),
            }}
          />
        </Col>
      </Row>
      {values.areIndividuals ? (
        <>
          <FieldArray name="individuals" render={renderIndividuals} />
          <HideIfDisabledForm hideIfSubmitting>
            <StyledButton size="large" onClick={addNewIndividual}>
              {t('intake_form.associated_individuals.add_another_individual')}
            </StyledButton>
          </HideIfDisabledForm>
        </>
      ) : null}
      <HideIfDisabledForm>
        <Divider />
        <SubmitButtons />
      </HideIfDisabledForm>
    </>
  );
};

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.marginSm};
`;

export default InnerForm;
